import { useEffect, useState } from 'react';
import loading from '../../assets/gif/loading.gif';
import { useApp } from '../../context/app';
import { Container } from './styles';

interface LoadingProps {
  shown: boolean;
}

export function Loading({ shown }: LoadingProps) {
  const { setLoading } = useApp();
  const [showCancellation, setShowCancellation] = useState(false);

  useEffect(() => {
    setShowCancellation(false);
    const timer = setTimeout(() => {
      setShowCancellation(true);
    }, 10000);
    return () => clearTimeout(timer);
  }, [shown]);

  return (
    <Container shown={shown}>
      <img src={loading} alt="Legal Control Hub Loading" />
      <p
        className={`${showCancellation ? 'shown' : ''}`}
        aria-hidden
        onClick={() => setLoading(false)}>
        Cancelar
      </p>
    </Container>
  );
}
